import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1899 16C12.3887 15.9999 12.5793 15.9207 12.7199 15.78L17.8499 10.64C17.8967 10.5936 17.9339 10.5383 17.9593 10.4773C17.9847 10.4164 17.9978 10.351 17.9978 10.285C17.9978 10.219 17.9847 10.1537 17.9593 10.0928C17.9339 10.0318 17.8967 9.97652 17.8499 9.93004L17.1499 9.22004C17.1034 9.17318 17.0481 9.13598 16.9871 9.1106C16.9262 9.08521 16.8609 9.07214 16.7949 9.07214C16.7288 9.07214 16.6635 9.08521 16.6026 9.1106C16.5416 9.13598 16.4863 9.17318 16.4399 9.22004L11.9999 13.67L7.55985 9.22004C7.51423 9.17348 7.45977 9.13649 7.39967 9.11123C7.33958 9.08598 7.27504 9.07297 7.20985 9.07297C7.14466 9.07297 7.08013 9.08598 7.02003 9.11123C6.95993 9.13649 6.90548 9.17348 6.85985 9.22004L6.14985 9.93004C6.10299 9.97652 6.06579 10.0318 6.04041 10.0928C6.01502 10.1537 6.00195 10.219 6.00195 10.285C6.00195 10.351 6.01502 10.4164 6.04041 10.4773C6.06579 10.5383 6.10299 10.5936 6.14985 10.64L11.2799 15.78C11.4216 15.9189 11.6114 15.9977 11.8099 16H12.1899Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDownOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDownOutline;
